import { render, staticRenderFns } from "./EditOrderDialog.vue?vue&type=template&id=eb45b68c"
import script from "./EditOrderDialog.vue?vue&type=script&lang=js"
export * from "./EditOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports